import { CommonSettingsService } from '@/services/api/settingsApiArea/CommonSettingsService';
import { CommonSettingsServiceType } from '@/services/api/settingsApiArea/interface';

/** Метод settingsApiArea возвращает экземпляр CommonSettingsService. По необходимости можно реализовать снгл тон. **/
export const commonSettingsApiArea: { (): CommonSettingsServiceType } = () =>
  new CommonSettingsService();
